import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const TOKEN_KEY = "ve_token";
const USER_KEY = "ve_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event("ve-auth-change"));
}
export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.dispatchEvent(new Event("ve-auth-change"));
}

export function useAuth() {
  const [user, setUser] = useState(getStoredUser());

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem(USER_KEY, JSON.stringify(data));
      return data;
    } catch {
      clearSession();
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const onChange = () => setUser(getStoredUser());
    window.addEventListener("ve-auth-change", onChange);
    if (getToken() && !user) refresh();
    return () => window.removeEventListener("ve-auth-change", onChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { user, refresh, isAdmin: user?.role === "admin", isAuthed: !!user };
}

export async function loginRequest(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  setSession(data.access_token, { email: data.email, role: data.role });
  return data;
}
export async function registerRequest(email, password, name) {
  const { data } = await api.post("/auth/register", { email, password, name });
  setSession(data.access_token, { email: data.email, role: data.role });
  return data;
}
